import type { IExercise } from '../exercises';

/** User-supplied 深蹲.zip, classified by its 分类说明.md. Each variation retains its own teaching. */
export const SQUAT_ADDITIONS = [
  {
    key: 'back-toes-out', libraryId: 'library-back-squat-toes-out', name: '颈后深蹲（脚尖外八）',
    teachingName: '颈后深蹲脚尖外八', reps: '8-12', pattern: '颈后负重脚尖外八深蹲',
    tips: ['按视频示范将杠铃放在颈后，双脚自然打开', '以轻重量对照脚尖外八的蹲起姿势', '控制下蹲与起身节奏'],
    detailGuide: ['本片用于对照常见的脚尖外八深蹲模式。', '与脚尖朝前变式分开保存，可分别查看教学和记录训练。'],
  },
  {
    key: 'back-toes-forward', libraryId: 'library-back-squat-toes-forward', name: '颈后深蹲（脚尖朝前）',
    teachingName: '颈后深蹲脚尖朝前', reps: '8-12', pattern: '颈后负重脚尖朝前深蹲',
    tips: ['按本片示范保持脚尖朝前，观察下蹲时脚是否向外滚', '在自己能控制的幅度内下蹲', '控制下放约2秒，避免用俯身弯腰代偿'],
    detailGuide: ['本片重点观察足部位置和下蹲时的稳定性。', '分类说明建议3–4组，动作库默认采用3组；可在自己的组合中调整。'],
  },
  {
    key: 'front-high-elbow', libraryId: 'library-front-squat-high-elbow', name: '颈前高肘深蹲',
    teachingName: '颈前高肘深蹲', reps: '8-12', pattern: '颈前高肘负重深蹲',
    tips: ['按视频示范把杠铃置于身体前侧', '下蹲与起身时持续抬高肘部', '保持可控的蹲起幅度和节奏'],
    detailGuide: ['本片讲解颈前高肘的持杠和蹲起方式，并介绍交叉臂持杠的选择。', '分类说明建议3–4组，动作库默认采用3组；可在自己的组合中调整。'],
  },
  {
    key: 'zercher', libraryId: 'library-zercher-squat', name: '泽奇架肘深蹲',
    teachingName: '泽奇架肘深蹲', reps: '10-15', pattern: '肘窝承杠泽奇深蹲',
    tips: ['按视频示范用双肘承托身体前侧的杠铃', '以轻重量练习持杠和蹲起', '保持能控制的动作幅度，稳定起身'],
    detailGuide: ['分类说明将本片列为退阶辅助动作，用于练习前侧持杠的蹲起模式。', '与颈前、颈后深蹲分别保留动作身份。'],
  },
  {
    key: 'padded-zercher', libraryId: 'library-padded-zercher-squat', name: '泽奇抱胸深蹲（加垫）',
    teachingName: '泽奇抱胸加垫深蹲', reps: '10-15', pattern: '加垫抱胸肘前推泽奇深蹲',
    tips: ['按视频示范在杠铃与胸腹之间放置软垫并抱住', '保持肘部向前推的姿势', '以轻重量练习抱杠与蹲起控制'],
    detailGuide: ['循环短片主要示范加垫抱杠和肘部前推，具体过程请查看完整教学。', '分类说明将此变式作为泽奇架肘与颈前深蹲之间的辅助练习。'],
  },
];

export const squatTeachingId = (key: string) => `course-squat-20261011-${key}`;
export const SQUAT_TEACHING_MATERIALS: IExercise[] = SQUAT_ADDITIONS.map(item => ({
  id: squatTeachingId(item.key), name: item.teachingName, bodyPart: 'legs', equipment: 'barbell',
  subCategory: 'quadriceps', tips: [...item.tips], detailGuide: [...item.detailGuide],
  sets: 3, reps: item.reps, rpe: 7, restSeconds: 90, isBodyweight: false, difficulty: 'intermediate',
  targetMuscles: ['股四头肌', '臀大肌'], source: '谭成义 · 深蹲力线', demoStatus: 'ready', demoFit: 'contain',
  demoUrl: `/training-media/squat-20261011/${item.key}-demo.mp4`,
  videoUrl: `/training-media/squat-20261011/${item.key}-tutorial.mp4`,
}));
